import React from 'react';
import { JourneyStrip } from './JourneyStrip';
import { MAIN_MOCKUP, MOCKUP_ALT, REVEAL_SUB, REVEAL_TITLE } from '../data/eatWellContent';
export function SystemRevealSection() {
  return <section className="w-full border-y border-champagne/20 bg-black py-12 sm:py-16" aria-labelledby="reveal-title" data-id="element-203" data-mp="1l0ktw8hggpwu">
      <div className="mx-auto max-w-5xl px-5 text-center" data-id="element-204" data-mp="1pxkysg2kjmmd">
        <p className="text-[11px] font-semibold uppercase tracking-[0.32em] text-champagne" data-id="element-205" data-mp="1b9q2kppcr04j">
          The solution
        </p>
        <h2 id="reveal-title" className="mt-3 font-display text-[1.7rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.5rem]" data-id="element-206" data-mp="1g1rmmxsrhv54">
          {REVEAL_TITLE}
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-[14px] leading-snug text-body sm:text-[16px]" data-id="element-207" data-mp="179651l0v9uhv">
          {REVEAL_SUB}
        </p>

        <div className="mt-6 border-y border-charcoal-600 py-4" data-id="element-208" data-mp="sdqbdh4780m0">
          <JourneyStrip data-id="element-209" data-mp="x9yx5dcwis25" />
        </div>

        <img src={MAIN_MOCKUP} alt={MOCKUP_ALT} className="mx-auto mt-8 w-full max-w-xl sm:max-w-3xl" width={1536} height={1024} data-id="element-210" data-mp="32ikk0j7phl6e" />
      </div>
    </section>;
}